module.exports = __webpack_public_path__ + "img/login-playgol.f82c1922.svg";